<template>
  <svg xmlns="http://www.w3.org/2000/svg" id="Camada_2" viewBox="0 0 20.6 32.31">
    <g id="Camada_1-2" data-name="Camada_1">
      <g>
        <path
          d="M10.3,4.35C4.63,4.35,0,8.98,0,14.65v7.37c0,5.66,4.63,10.3,10.3,10.3s10.3-4.63,10.3-10.3v-7.37c0-5.66-4.63-10.3-10.3-10.3ZM18.14,22.02c0,4.33-3.51,7.84-7.84,7.84h0c-4.33,0-7.84-3.51-7.84-7.84v-7.56c0-4.33,3.51-7.84,7.84-7.84h0c4.33,0,7.84,3.51,7.84,7.84v7.56Z" />
        <rect x="8.88" y="9.83" width="2.83" height="6.24" rx="1.42" ry="1.42" />
        <rect x="8.88" y="0" width="2.83" height="5.48" rx="1.42" ry="1.42" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CampaignIcon'
}
</script>
